import { render, staticRenderFns } from "./LampiranPlain.vue?vue&type=template&id=2b3eb3b4&scoped=true&lang=pug&"
import script from "./LampiranPlain.vue?vue&type=script&lang=js&"
export * from "./LampiranPlain.vue?vue&type=script&lang=js&"
import style0 from "./LampiranPlain.vue?vue&type=style&index=0&id=2b3eb3b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3eb3b4",
  null
  
)

export default component.exports